import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

interface DashboardLayoutProps {
    onLoginClick: () => void;
    onRegisterClick: () => void;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ onLoginClick, onRegisterClick }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <div className="flex flex-col min-h-screen bg-[var(--st-bg-body)]">

            {/* Navbar PRIVADO (Con acción de menú hamburguesa) */}
            <Navbar
                onLoginClick={onLoginClick}
                onRegisterClick={onRegisterClick}
                onMenuClick={() => setIsMobileMenuOpen(true)}
            />

            <div className="flex st-container pt-0 relative flex-grow">

                {/* Sidebar conectado al estado local */}
                <Sidebar
                    isOpen={isMobileMenuOpen}
                    onClose={() => setIsMobileMenuOpen(false)}
                />
                <main className="flex-1 min-w-0 py-8 px-0 md:px-8 w-full">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;